// extracted by mini-css-extract-plugin
module.exports = {"main":"RichText_main__L_7T3"};